import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { keycloak } from './service/KeyCloakService';
import { Route, Routes } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import { AppMenu } from './AppMenu';
import Curriculum  from './components/cat/Curriculum';
import AppContext from './AppContext';
//import 'primereact/resources/themes/bootstrap4-light-blue/theme.css';
//import 'primereact/resources/themes/fluent-light/theme.css';
//import 'primereact/resources/themes/nano/theme.css';
import 'primereact/resources/themes/mira/theme.css';
//import 'primereact/resources/themes/tailwind-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './App.scss';
import './layout/flags/flags.css';
import './layout/layout.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { confirmPopup, ConfirmPopup} from 'primereact/confirmpopup';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useTranslation, initReactI18next } from "react-i18next";
import PilotTopbar from './PilotTopbar';
import MainPage from './components/common/MainPage';
import { QueBank } from './components/cms/bank/QueBank';
import { QueEditPageNew, QueEditPageUpdate } from './components/cms/question/QueEditPage';
import { QueGridPageLink } from './components/cms/question/QueGridPage';
import { QueImportWizardLink } from './components/cms/question/QueImportWizard';
import { GrpEditPageNew, GrpEditPageUpdate } from './components/cms/question/GrpEditPage';
import WrkPage from './components/cat/wrk/WrkGrid';
import { QueReview } from './components/cms/question/QueReview';
import { TempEditPageNew, TempEditPageUpdate } from './components/cms/temp/TempEditPage';
import { CrtPage } from './components/cms/crt/CrtPage';
import { AutoSelectWizardLink } from './components/cms/crt/AutoSelectWizard';
import { QueImportList } from './components/cms/question/QueImportList';
import { QueFromImage } from './components/cms/question/QueFromImage';

const PilotApp = () => {

    const [layoutMode, setLayoutMode] = useState('static');
    const [layoutColorMode, setLayoutColorMode] = useState('dark')
    const [staticMenuInactive, setStaticMenuInactive] = useState(false);
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [inputStyle, setInputStyle] = useState('outlined');
    const [ripple, setRipple] = useState(false);
    const { t, i18n } = useTranslation();

    const sidebar = useRef();
    let menuClick = false;

    useEffect(() => {
        if (mobileMenuActive) {
            addClass(document.body, 'body-overflow-hidden');
        }
        else {
            removeClass(document.body, 'body-overflow-hidden');
        }
    }, []);


    const onInputStyleChange = (inputStyle) => {
        setInputStyle(inputStyle);
    }

    const onRipple = (e) => {
        //PrimeReact.ripple = e.value;
        setRipple(e.value)
    }

    const onLayoutModeChange = (mode) => {
        setLayoutMode(mode)
    }

    const onColorModeChange = (mode) => {
        setLayoutColorMode(mode)
    }

    const onWrapperClick = (event) => {
        if (!menuClick) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }
        menuClick = false;
    }

    const onToggleMenu = (event) => {
        menuClick = true;

        if (isDesktop()) {
            if (layoutMode === 'overlay') {
                setOverlayMenuActive(prevState => !prevState);
            }
            else if (layoutMode === 'static') {
                setStaticMenuInactive(prevState => !prevState);
            }
        }
        else {
            setMobileMenuActive(prevState => !prevState);
        }
        event.preventDefault();
    }

    const onSidebarClick = () => {
        menuClick = true;
    }

    const onMenuItemClick = (event) => {
        if (!event.item.items) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }
    }

    const hasRole=(role)=>{
        const clientRoles = keycloak.resourceAccess?.['pls-cms']?.roles || [];
        console.log("Client Roles:", clientRoles);        
        let perm=keycloak.hasResourceRole(role,'pls-cms');        
        return perm;
    }
    const menu = [
        {
            label: t('Home'), icon: 'pi pi-fw pi-home', to: '/home'
        },
        {
            label: t('Work List'), icon: 'pi pi-fw pi-list-check', to: '/wrks'
        },        
        {
            label: t('Curriculum'), icon: 'pi pi-fw pi-sitemap', to: '/curriculum'
        },
        {
            label: t('Item Bank'), icon: 'pi pi-fw pi-database', to: '/itembank', hidden:!(hasRole('cms:que:author')||hasRole('cms:que:view'))
        }                 
    ];

    const addClass = (element, className) => {
        if (element.classList)
            element.classList.add(className);
        else
            element.className += ' ' + className;
    }

    const removeClass = (element, className) => {
        if (element.classList)
            element.classList.remove(className);
        else
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    const isDesktop = () => {
        return window.innerWidth > 1024;
    }

    const isSidebarVisible = () => {
        if (isDesktop()) {
            if (layoutMode === 'static')
                return !staticMenuInactive;
            else if (layoutMode === 'overlay')
                return overlayMenuActive;
            else
                return true;
        }

        return true;
    }

    const logo = layoutColorMode === 'dark' ? 'assets/layout/images/logo-white.svg' : 'assets/layout/images/logo.svg';

    const wrapperClass = classNames('layout-wrapper', {
        'layout-overlay': layoutMode === 'overlay',
        'layout-static': layoutMode === 'static',
        'layout-static-sidebar-inactive': staticMenuInactive && layoutMode === 'static',
        'layout-overlay-sidebar-active': overlayMenuActive && layoutMode === 'overlay',
        'layout-mobile-sidebar-active': mobileMenuActive,
        'p-input-filled': inputStyle === 'filled',
        'p-ripple-disabled': ripple === false
    });

    const sidebarClassName = classNames('layout-sidebar', {
        'layout-sidebar-dark': layoutColorMode === 'dark',
        'layout-sidebar-light': layoutColorMode === 'light'
    });

    const _ctx = {clip:[],appName:'pls-cat',clipType:'ROOT'};

    return (
        <AppContext.Provider value = {_ctx}>
        <div className={wrapperClass} onClick={onWrapperClick}>
            <PilotTopbar onToggleMenu={onToggleMenu} />

            <CSSTransition classNames="layout-sidebar" timeout={{ enter: 200, exit: 200 }} in={isSidebarVisible()} unmountOnExit>
                <div ref={sidebar} className={sidebarClassName} onClick={onSidebarClick}>
                    <div className="layout-logo" style={{paddingBottom:'50px'}}>
                        <img alt="Logo" src={logo} />
                    </div>
                    <AppMenu model={menu} onMenuItemClick={onMenuItemClick} />
                </div>
            </CSSTransition>

            <div className="layout-main flex flex-column" style={{ 
                height: '100vh', 
                paddingTop: '70px', // Pushes content below the fixed topbar
                boxSizing: 'border-box' 
            }}>                
                <Routes>
                <Route path="/home" element={<MainPage/>} />  
                <Route path="/wrks" element={<WrkPage/>} />  
				<Route path="/curriculum" element={<Curriculum/>} />
                <Route path="/itembank" element={<QueBank/>} />
                <Route path="/itembank/add/:courseId" element={<QueEditPageNew/>} />
                <Route path="/itembank/addgrp/:courseId" element={<GrpEditPageNew/>} />
                <Route path="/itembank/addquetogrp/:grpId" element={<QueEditPageNew/>} />
                <Route path="/itembank/cats/:id/questions" element={<QueGridPageLink/>} />
                <Route path="/itembank/cats/:id/questions/load" element={<QueImportWizardLink/>} />
                <Route path="/itembank/grp/:id" element={<GrpEditPageUpdate/>} />
                <Route path="/itembank/question/:id" element={<QueEditPageUpdate/>} />
                <Route path="/itembank/question/:id/review" element={<QueReview/>} />
                <Route path="/itembank/temp" element={<TempEditPageNew/>} />
                <Route path="/itembank/temp/:id" element={<TempEditPageUpdate/>} />
                <Route path="/itembank/crt/:id" element={<CrtPage/>} />
                <Route path="/itembank/crt/:id/select" element={<AutoSelectWizardLink/>} />
                <Route path="/itembank/imports/:id" element={<QueImportList/>} />      
                <Route path="/itembank/addquefromimg/:courseId" element={<QueFromImage/>} />                          
                </Routes>
            </div>
            {/*<div className="layout-mask"></div>*/}
        </div>
        </AppContext.Provider>
    );

}

export default PilotApp;
